
<div class="content" 	
	[innerHtml]="body"
></div>